/* SOCKSSS – Riktning B · header + menu drawer */
(function () {
  if (window.__rbInit) return;
  window.__rbInit = true;

  function init() {
    var menu = document.querySelector('[data-rb-menu]');
    if (!menu) return;
    var openers = document.querySelectorAll('[data-rb-menu-open]');
    var lastFocus = null;

    // per tab / sub menu colours (blocks in the header section): sub > tab > menu default
    function paint(el) {
      var src = el && el.dataset.rbBg ? el : menu;
      menu.style.setProperty('--rb-menu-bg', src.dataset.rbBg || '');
      menu.style.setProperty('--rb-menu-text', src.dataset.rbText || '');
      curBg = src.dataset.rbBg || menu.dataset.rbBg || '';
      if (menu.classList.contains('is-open')) tint(true);
    }
    // iPhone Safari colours its top and bottom bars from the page: while the menu is open give them the menu colour
    // (fixed element background, page background and theme-color), and put everything back on close
    var meta = document.querySelector('meta[name="theme-color"]'), metaOld = meta ? meta.content : null;
    var panel = menu.querySelector('.rb-menu__panel'), curBg = menu.dataset.rbBg || '';
    function tint(on) {
      var html = document.documentElement;
      if (!on) {
        menu.style.backgroundColor = ''; html.style.backgroundColor = ''; document.body.style.backgroundColor = '';
        if (meta) { if (metaOld === null) meta.remove(); else meta.content = metaOld; meta = metaOld === null ? null : meta; }
        return;
      }
      // only when the menu covers the whole screen (mobile); on desktop the page stays visible next to it
      if (!panel || panel.getBoundingClientRect().width < window.innerWidth - 1) return;
      var bg = curBg;  // the colour itself, not the panel's computed colour (that may still be fading)
      if (!bg) return;
      menu.style.backgroundColor = bg; html.style.backgroundColor = bg; document.body.style.backgroundColor = bg;
      if (!meta) { meta = document.createElement('meta'); meta.name = 'theme-color'; document.head.appendChild(meta); }
      meta.content = bg;
    }
    function currentPane() { return menu.querySelector('[data-rb-pane]:not([hidden])'); }

    function open() {
      lastFocus = document.activeElement;
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      document.body.classList.add('rb-lock');
      paint(currentPane());
      tint(true);
      var first = menu.querySelector('.rb-menu__tab, a, button');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 50);
    }
    function close() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.body.classList.remove('rb-lock');
      resetSubs();
      tint(false);
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    }
    function resetSubs() {
      menu.querySelectorAll('[data-rb-sub]').forEach(function (s) { s.hidden = true; });
      menu.querySelectorAll('[data-rb-root]').forEach(function (r) { r.hidden = false; });
      paint(currentPane());
    }
    function selectTab(i) {
      menu.querySelectorAll('[data-rb-tab]').forEach(function (t) {
        t.setAttribute('aria-selected', t.dataset.rbTab === i ? 'true' : 'false');
      });
      menu.querySelectorAll('[data-rb-pane]').forEach(function (p) {
        p.hidden = p.dataset.rbPane !== i;
      });
      resetSubs();
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    menu.querySelectorAll('[data-rb-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
    });

    menu.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-rb-tab]');
      if (tab) { selectTab(tab.dataset.rbTab); return; }

      var subOpen = e.target.closest('[data-rb-sub-open]');
      if (subOpen) {
        var pane = subOpen.closest('[data-rb-pane]');
        var sub = pane.querySelector('[data-rb-sub="' + subOpen.dataset.rbSubOpen + '"]');
        if (sub) {
          pane.querySelector('[data-rb-root]').hidden = true;
          sub.hidden = false;
          paint(sub.dataset.rbBg ? sub : pane);
          var back = sub.querySelector('[data-rb-sub-back]');
          if (back) back.focus({ preventScroll: true });
        }
        return;
      }
      if (e.target.closest('[data-rb-sub-back]')) { resetSubs(); return; }

      var cartLink = e.target.closest('[data-rb-cart-link]');
      var bubble = document.getElementById('cart-icon-bubble');
      if (cartLink && bubble && document.querySelector('cart-drawer')) {
        e.preventDefault();
        close();
        bubble.click();
      }
    });

    // keep the in-menu cart count in sync with the header bubble
    var bubbleEl = document.getElementById('cart-icon-bubble');
    if (bubbleEl && 'MutationObserver' in window) {
      new MutationObserver(function () {
        menu.querySelectorAll('[data-rb-cart-link]').forEach(function (l) { l.textContent = bubbleEl.textContent.trim(); });
      }).observe(bubbleEl, { childList: true, characterData: true, subtree: true });
    }
  }

  function initSearch() {
    var link = document.querySelector('[data-rb-search-open]');
    var form = document.querySelector('[data-rb-search-form]');
    if (!link || !form || form.__rb) return;
    form.__rb = true;
    var input = form.querySelector('input[type="search"]');
    var onSearchPage = !form.hidden;
    link.addEventListener('click', function (e) {
      if (window.matchMedia('(max-width: 749px)').matches) return;
      e.preventDefault();
      link.hidden = true;
      form.hidden = false;
      input.focus();
    });
    function collapse() {
      if (onSearchPage || input.value.trim() !== '') return;
      form.hidden = true;
      link.hidden = false;
    }
    input.addEventListener('blur', function () { setTimeout(collapse, 150); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; input.blur(); collapse(); } });
    form.addEventListener('submit', function (e) { if (input.value.trim() === '') e.preventDefault(); });
  }

  /* header: hide on scroll down, show on scroll up */
  function initSticky() {
    var header = document.querySelector('[data-rb-header]');
    if (!header || header.__rbSticky) return;
    header.__rbSticky = true;
    var lastY = window.scrollY, ticking = false;
    function update() {
      ticking = false;
      var y = Math.max(window.scrollY, 0);
      var h = header.offsetHeight;
      if (document.body.classList.contains('rb-lock')) { lastY = y; return; }
      if (y <= h) {
        header.classList.remove('is-hidden', 'is-pinned');
      } else if (y > lastY + 4) {
        header.classList.add('is-hidden');
        header.classList.remove('is-pinned');
      } else if (y < lastY - 4) {
        header.classList.remove('is-hidden');
        header.classList.add('is-pinned');
      }
      lastY = y;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* hover stickers: random cards get a random illustration on hover */
  function initStickers() {
    var el = document.getElementById('rb-stickers');
    if (!el || document.__rbStickers) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var cfg;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
    var urls = (cfg.urls || []).filter(Boolean);
    if (!urls.length) return;
    document.__rbStickers = true;
    var chance = (cfg.chance || 25) / 100;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    urls.forEach(function (u) { var i = new Image(); i.src = u; }); // preload

    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest && e.target.closest('.rb-card--product');
      if (!card || card.contains(e.relatedTarget)) return;
      if (card.__rbLucky === undefined) card.__rbLucky = Math.random() < chance;
      if (!card.__rbLucky) return;
      var media = card.querySelector('.rb-card__media');
      if (!media) return;
      var old = card.querySelector('.rb-sticker');
      if (old) old.remove();
      var img = document.createElement('img');
      img.className = 'rb-sticker';
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.src = urls[Math.floor(Math.random() * urls.length)];
      var w = media.offsetWidth, h = media.offsetHeight;
      var size = Math.min(cfg.size || 180, w * 0.7);
      img.style.width = size + 'px';
      img.style.left = Math.round(Math.random() * Math.max(w - size, 0)) + 'px';
      img.style.top = Math.round(h * 0.1 + Math.random() * Math.max(h * 0.8 - size, 0)) + 'px';
      card.appendChild(img);
      if (!reduce) requestAnimationFrame(function () { img.classList.add('is-in'); });
      else img.classList.add('is-in');
    });
    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest && e.target.closest('.rb-card--product');
      if (!card || card.contains(e.relatedTarget)) return;
      var s = card.querySelector('.rb-sticker');
      if (!s) return;
      s.classList.remove('is-in');
      setTimeout(function () { if (s.parentNode && !s.classList.contains('is-in')) s.remove(); }, 250);
    });
  }

  /* emoji cursor: random images swap the pointer for an emoji that follows the mouse */
  function initCursor() {
    var el = document.getElementById('rb-cursor');
    if (!el || document.__rbCursor) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var cfg;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
    var emojis = (cfg.emojis || []).filter(function (x) { return x && x.trim(); });
    if (!emojis.length) return;
    document.__rbCursor = true;
    var chance = (cfg.chance || 30) / 100;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sel = {
      products: '.rb-card--product .rb-card__media',
      editorial: '.rb-hero, .rb-card:not(.rb-card--product) .rb-card__media, .rb-about__media, .rb-follow__grid .rb-card__media',
    };
    sel.all = sel.products + ', ' + sel.editorial + ', .rb-pdp__media';
    var targets = sel[cfg.scope] || sel.all;

    var dot = document.createElement('div');
    dot.className = 'rb-cursor';
    dot.setAttribute('aria-hidden', 'true');
    dot.style.fontSize = (cfg.size || 44) + 'px';
    document.body.appendChild(dot);

    var x = 0, y = 0, cx = 0, cy = 0, active = null, raf = null;
    function loop() {
      cx += (x - cx) * (reduce ? 1 : 0.35);
      cy += (y - cy) * (reduce ? 1 : 0.35);
      dot.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)';
      raf = active ? requestAnimationFrame(loop) : null;
    }
    function show(t, e) {
      active = t;
      t.classList.add('rb-cursor-on');
      dot.textContent = t.__rbEmoji;
      cx = x = e.clientX; cy = y = e.clientY;
      dot.classList.add('is-on');
      if (!raf) raf = requestAnimationFrame(loop);
    }
    function hide() {
      if (active) active.classList.remove('rb-cursor-on');
      active = null;
      dot.classList.remove('is-on', 'is-down');
    }

    document.addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY;
      var t = e.target.closest ? e.target.closest(targets) : null;
      // keep the real pointer over links/buttons inside the image (e.g. hero text link, quick add strip)
      if (t && e.target.closest('.rb-hero__content a, button, [data-rb-qa]')) t = null;
      if (t && t.__rbLucky === undefined) {
        t.__rbLucky = Math.random() < chance;
        t.__rbEmoji = emojis[Math.floor(Math.random() * emojis.length)];
      }
      if (t && t.__rbLucky) { if (active !== t) { hide(); show(t, e); } }
      else if (active) hide();
    }, { passive: true });
    document.addEventListener('mouseleave', hide);
    window.addEventListener('scroll', function () { if (active) hide(); }, { passive: true });
    document.addEventListener('mousedown', function () { if (active) dot.classList.add('is-down'); });
    document.addEventListener('mouseup', function () { dot.classList.remove('is-down'); });
  }

  /* scroll animations: fade-up + staggered cards/images (only below the fold, only once) */
  function initReveal() {
    var el = document.getElementById('rb-anim');
    if (!el || document.__rbReveal || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.__rbReveal = true;
    var cfg = {};
    try { cfg = JSON.parse(el.textContent); } catch (e) {}
    var strong = cfg.strength === 'strong';
    var root = document.documentElement;
    root.style.setProperty('--rb-rev-y', strong ? '32px' : '16px');
    root.style.setProperty('--rb-rev-d', strong ? '.9s' : '.7s');
    var DUR = strong ? 900 : 700;

    var FADE = [
      '.rb-head', '.rb-text', '.rb-coll__text', '.rb-coll__bar', '.rb-search__head', '.rb-recs__title',
      '.rb-about__title', '.rb-about__text', '.rb-page__aside', '.rb-acc', '.rb-form', '.rb-page__app',
      '.rb-pdp__info-body', '.rb-footer__top'
    ].join(',');
    var CARDS = '.rb-grid > *, .rb-pair > *, .rb-follow__grid > *';
    var IMAGES = '.rb-about__media';

    var queue = [], flushT = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        (en.target.__rbTargets || []).forEach(function (t) { queue.push(t); });
        en.target.__rbTargets = null;
      });
      if (queue.length && !flushT) flushT = requestAnimationFrame(flush);
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    function flush() {
      flushT = null;
      // stagger items that enter together (e.g. a row of product cards)
      queue.sort(function (a, b) {
        var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
        return (ra.top - rb.top) || (ra.left - rb.left);
      });
      var i = 0;
      queue.forEach(function (t) {
        var delay = t.__rbStagger ? Math.min(i++, 8) * 70 : 0;
        t.style.setProperty('--rb-delay', delay + 'ms');
        t.classList.add('is-in');
        setTimeout(function () {
          t.classList.remove('rb-reveal', 'rb-reveal-img', 'is-in');
          t.style.removeProperty('--rb-delay');
        }, DUR + delay + 450);
      });
      queue = [];
    }

    function mark(t, cls, stagger) {
      if (t.__rbRev) return;
      t.__rbRev = true;
      if (t.getBoundingClientRect().top < window.innerHeight) return; // already visible: leave it alone
      t.__rbStagger = stagger;
      t.classList.add(cls);
      // clipped images can't be observed themselves (zero visible area) – watch their parent instead
      var proxy = cls === 'rb-reveal-img' ? t.parentElement : t;
      (proxy.__rbTargets = proxy.__rbTargets || []).push(t);
      io.observe(proxy);
    }
    function scan() {
      document.querySelectorAll(FADE).forEach(function (t) { mark(t, 'rb-reveal', false); });
      document.querySelectorAll(CARDS).forEach(function (t) { mark(t, 'rb-reveal', true); });
      document.querySelectorAll(IMAGES).forEach(function (t) { mark(t, 'rb-reveal', true); });
    }
    scan();
    // cards added later (endless scroll, recommendations)
    var mt = null;
    new MutationObserver(function () {
      clearTimeout(mt);
      mt = setTimeout(scan, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* mobile order: a number = that position on mobile (1 = first). Sections left at 0 fill the
     remaining positions in the same order as on desktop. */
  function initMobileOrder() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var secs = Array.prototype.slice.call(main.children).filter(function (el) { return el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE'; });
    var nums = secs.map(function (sec) {
      var m = sec.querySelector('[data-rb-mo]');
      return m ? parseInt(m.getAttribute('data-rb-mo'), 10) || 0 : 0;
    });
    if (!nums.some(function (n) { return n > 0; })) { secs.forEach(function (s) { s.style.removeProperty('order'); }); return; }
    var slots = [];
    // numbered sections first, lowest number wins a clash
    secs.map(function (s, k) { return k; })
      .filter(function (k) { return nums[k] > 0; })
      .sort(function (a, b) { return nums[a] - nums[b] || a - b; })
      .forEach(function (k) {
        var p = nums[k] - 1;
        while (slots[p] !== undefined) p++;
        slots[p] = secs[k];
      });
    var p = 0;
    secs.forEach(function (s, k) {
      if (nums[k] > 0) return;
      while (slots[p] !== undefined) p++;
      slots[p] = s;
    });
    var n = 0;
    slots.forEach(function (s) { if (s) s.style.order = ++n; });
  }

  /* product card swipe gallery (mobile): move the position line as the images scroll */
  function initCardGalleries() {
    if (document.__rbCardGal) return;
    document.__rbCardGal = true;
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-rb-card-track]')) return;
      var w = t.clientWidth || 1;
      var i = Math.round(t.scrollLeft / w);
      if (t.__rbI !== i) { t.__rbI = i; t.parentNode.style.setProperty('--i', i); }
    }, { capture: true, passive: true });
    function step(track, dir, wrap) {
      var w = track.clientWidth;
      var max = track.scrollWidth - w;
      var to = Math.round(track.scrollLeft / w) * w + dir * w;
      if (to > max + 2) { if (!wrap) return; to = 0; } // past the last image: back to the first
      track.scrollTo({ left: Math.max(0, Math.min(to, max)), behavior: 'smooth' });
    }
    // desktop arrows: step one image, don't follow the card link
    document.addEventListener('click', function (e) {
      var nav = e.target.closest && e.target.closest('[data-rb-card-nav]');
      if (!nav) return;
      e.preventDefault();
      e.stopPropagation();
      var track = nav.parentNode.querySelector('[data-rb-card-track]');
      if (track) step(track, parseInt(nav.dataset.rbCardNav, 10), true);
    }, true);
    // desktop trackpad: sideways swipe steps one image; vertical scrolling always goes to the page
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var lockUntil = 0;
    document.addEventListener('wheel', function (e) {
      if (!fine.matches) return;
      var track = e.target.closest && e.target.closest('[data-rb-card-track].is-multi');
      if (!track) return;
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 4) return;
      e.preventDefault();
      var now = Date.now();
      if (now < lockUntil) return;
      lockUntil = now + 500;
      step(track, e.deltaX > 0 ? 1 : -1, false);
    }, { passive: false });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initCardGalleries(); initMobileOrder(); init(); initSearch(); initSticky(); initStickers(); initCursor(); initReveal(); });
  else { initCardGalleries(); initMobileOrder(); init(); initSearch(); initSticky(); initStickers(); initCursor(); initReveal(); }

  document.addEventListener('shopify:section:load', function () { window.__rbInit = false; init(); window.__rbInit = true; });
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(initMobileOrder, 0); }); });
})();
